<!-- 仪表盘-已弃用 -->
<template>
  <div
    class="CMap wrapper">
    <!-- TopBar -->
    <CTopBar></CTopBar>
    <div class="appContent">
      <!-- 仪表盘侧边栏 -->
      <div
        class="MapNavBar">

        <!--返回按钮-->
        <!-- <i class="return ico ico-round-left-fill" v-if="currentLevelMap !=='country' && keywords === ''" @click="back"></i> -->

        <!--企业搜索框-->
        <div class="search">
          <el-input class="input" v-model="keywords" placeholder="企业名称">
            <!-- clearable -->
          </el-input>
          <i class="icon el-icon-search" @click="searchSpace"></i>
        </div>

        <!--显示设备列表-->
        <div class="deviceList">
          <el-table
            class="table"
            ref="singleTable"
            :data="currentMapList"
            header-row-class-name="list-title"
            row-class-name="list-row"
            highlight-current-row
            @row-click="getNewMapList">
            <el-table-column
              :label="currentTableFirstLabel">
              <template slot-scope="scope">
                <div class="deviceMapInfo">
                  {{scope.row.area_name}}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="设备数量">
              <template slot-scope="scope">
                <div class="deviceMapInfo">
                  {{scope.row.total}}
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 更多模块连接 -->
        <router-link class="moreLink" to="/CIndex">控制台</router-link>
      </div>
      <div class="rightArea">
        <!-- 地图区域 -->
        <div id="allmap" :class="{hide: currentLevelMap == 'area'}"></div>
        <!-- 设备中心 -->
        <div class="deviceCenter">
          <cdevicecomponent></cdevicecomponent>
        </div>
        <!-- 按钮区域 -->
        <div class="btnArea">
          <router-link class="btn" to="/CMap">
            <i class="el-icon-s-home"></i>
            <span class="text">主地图</span>
          </router-link>
          <li class="btn" v-if="currentLevelMap !=='country' && keywords === ''" @click="back">
            <i class="el-icon-caret-top"></i>
            <span class="text">上一级</span>
          </li>
        </div>
        <!-- 右侧悬浮信息 -->
        <div class="suspendInfoScrollWrapper">
          <div class="suspendInfoScrollBox">
            <el-collapse class="infoSuspendWrapper" v-model="activeNames" v-if="currentLevelMap != 'area'">
              <el-collapse-item class="box" title="设备状态" name="1">
                <!-- 设备 -->
                <div class="content" v-if="analyzeData.activation_rate.device_type.length != 0">
                  <!-- Swiper -->
                  <swiper :options="swiperOption" ref="mySwiper">
                    <!-- slides -->
                    <swiper-slide
                      class="swiper-no-swiping"
                      :class="{activeDevice: activeDevice == index,opacity: index<activeIndex || index>activeIndex+4}"
                      v-for="(item, index) in analyzeData.activation_rate.device_type"
                      :key="item.device_type_id"><p @click="click1(index)">{{item.name}}</p></swiper-slide>
                    <!-- Optional controls -->
                    <div class="swiper-button-prev el-icon-caret-bottom" slot="button-prev"></div>
                    <div class="swiper-button-next el-icon-caret-top" slot="button-next"></div>
                    <div class="swiper-scrollbar"></div>
                  </swiper>
                  <!-- 设备信息 -->
                  <div class="circle">
                    <p class="text">启用率</p>
                    <p class="text rate">{{analyzeData.activation_rate.device_type[activeDevice].rate}}%</p>
                    <p class="text total">总数： {{analyzeData.activation_rate.device_type[activeDevice].total}}</p>
                  </div>
                </div>
              </el-collapse-item>
              <el-collapse-item class="box" title="空间分布" name="2">
                <div id="spaceDis"></div>
              </el-collapse-item>
              <el-collapse-item class="box" title="预警中心" name="3">
                <div class="errorCenter">
                  <el-table
                    height="210"
                    :data="analyzeData.warning_log"
                    header-cell-class-name="headerStyle"
                    cell-class-name="cellStyle">
                    <el-table-column
                      prop="date"
                      label="时间">
                    </el-table-column>
                    <el-table-column
                      prop="device_no_id"
                      label="告警设备">
                    </el-table-column>
                    <el-table-column
                      prop="log"
                      label="内容">
                    </el-table-column>
                  </el-table>
                </div>
              </el-collapse-item>
            </el-collapse>
          </div>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
  import CTopBar from '@/components/Page/Layout/CTopBar.vue'
  import cdevicecomponent from './Page/CSceneManage/CDeviceComponent.vue'
  import { swiper, swiperSlide } from 'vue-awesome-swiper'
  import { mapApi } from "../../static/js/api.js"
  import { showToast } from '../../static/js/utility/utility'
  let echarts = require('echarts')

  export default {
    name: 'CMap',
    components: {
      CTopBar,
      swiper,
      swiperSlide,
      cdevicecomponent
    },
    data() {
      return {
        // 设备信息-当前选中设备
        activeIndex: 0,
        activeDevice: 0,
        // 设备信息分布
        analyzeData: {
          activation_rate: {
            device_type: []
          }
        },
        keywords: '',
        commonUrl: '#/CMap/',
        currentLevelMap:'country',
        currentId: '',
        currentMapList:[],
        // currentMapList: [
        //   {
        //     area_level: "city",
        //     area_name: "北京市",
        //     id: "4",
        //     latitude: "39.929985778080237",
        //     longitude: "116.39564503787867",
        //     total: "5"
        //   },
        // ],
        currentTableFirstLabel: '',
        defaultLocation:[113.3948175587587,23.40800372902474],
        activeNames: ['1', '2', '3'],
        swiperOption: {
          speed: 300,
          slidesPerView: 'auto',
          freeMode: true,
          direction: 'vertical',
          setWrapperSize: true,
          scrollbar: {
            el: '.swiper-scrollbar',
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          observer:true,
          noSwiping: true,
          on:{
            slideChange: ()=>{
              // 切换设备状态当前设备
              this.activeIndex = this.$refs.mySwiper.swiper.activeIndex
              // console.log('activeIndex', this.$refs.mySwiper.swiper.activeIndex)
            }
          }
        },
      }
    },
    computed: {
      swiper() {
        return this.$refs.mySwiper.swiper
      }
    },
    mounted(){
      this.mapInit()
      if (this.currentLevelMap != 'area') {
        this.analyze()
      }
    },
    created () {
      this.currentLevelMap = this.$route.params.mapLevel || 'country'
      this.currentId = this.$route.params.id || '1'
    },
    methods: {
      // 悬浮框--切换设备状态当前设备
      click1 (clickedIndex) {
        // 切换设备状态当前设备
        this.clickedIndex = clickedIndex
        let activeIndex = this.$refs.mySwiper.swiper.activeIndex
        if (clickedIndex != undefined && (clickedIndex >= activeIndex && clickedIndex <= activeIndex + 4) ) { this.activeDevice = clickedIndex }
        this.activeIndex = activeIndex
        // console.log('clickedIndex', clickedIndex)
        // console.log('activeIndex', this.$refs.mySwiper.swiper.activeIndex)
      },
      // 获取仪表盘设备信息分布
      async analyze () {
        let vm = this
        let res = await mapApi.analyze()
        // console.log('res', res)
        if (res.meta.code === 200) {
          this.analyzeData = res.data
          this.createChart(res.data.space_distribution)
        } else {
          showToast(res.meta.message)
        }
      },
      // 处理柱状图数据
      processParams (data) {
        // console.log('data', data)
        let source = [], deviceNameArr = []
        // 获取legend
        data.forEach(function (item, index) {
          item.device_list.forEach(function (dItem, dIndex) {
            if (deviceNameArr.indexOf(dItem.device_name) == -1) {
              deviceNameArr.push(dItem.device_name)
            }
          })
        })

        // 获取source
        let arr = []
        source[0] = ['product'].concat(deviceNameArr)
        data.forEach(function (item, index) {
          arr[index] = [item.space_name]
          item.device_list.forEach(function (dItem, dIndex) {
            deviceNameArr.forEach(function (dNItem, dNIndex) {
              arr[index].length = deviceNameArr.length
              if (dNItem == dItem.device_name) {
                // console.log('dNIndex+1:::', dNIndex+1)
                arr[index][dNIndex+1] = dItem.number
              }
            })

          })
        })
        source = source.concat(arr)
        
        // console.log('deviceNameArr:::', deviceNameArr)
        // console.log('source:::', source)
        // console.log('arr::::', arr)

        let series = []
        let seriesItem = {type: 'bar', barWidth: 16, barGap: 0}
        for (let i = 0; i < deviceNameArr.length; i++) {
          series[i] = seriesItem
        }

        let params = { source, series }
        // console.log('params', params)
        return params
      },
      // 空间分布加载图表
      createChart (data) {
        let params = this.processParams(data) 
        let total = this.analyzeData.space_distribution.length
        // 基于准备好的dom，初始化echarts实例
        var myChart = echarts.init(document.getElementById('spaceDis'));
        // 指定图表的配置项和数据
        var option = {
          // 文字样式
          textStyle: {
            color: '#666666',
          },
          legend: {
            type: 'scroll',
            itemWidth: 12,
            itemHeight: 12,
            left: 35,
            right: 35,
            bottom: 22,
            borderRadius: [0, 0, 0, 0],
            textStyle: {
              color: '#666666',
              lineHeight: 16
            }
          },
          grid: {
            bottom: 70,
          },
          // color: ['#ffa666', '#ff6673', '#66b5ff'],
          tooltip: {},
          dataset: {
            // source: [
            //   ['product', '门禁', '电表', '活动柜'],
            //   ['总裁办', 43.3, 85.8, 93.7],
            //   ['研发部', 83.1, 73.4, 55.1],
            //   ['市场部', 86.4, 65.2, 82.5],
            //   ['销售测试部', 72.4, 53.9, 39.1],
            //   ['市场测试部', 86.4, 65.2, 82.5],
            //   ['销售测试部', 72.4, 53.9, 39.1]
            // ]
            // source: [
            //   {product: '总裁办', '门禁': 43.3, '电表': '85.8', '活动柜': '93.7', '魔方柜': 43.3, '周转柜': '85.8', '电控': '93.7', 'e站': '93.7'}
            // ]
            source: params.source
          },
          series: params.series,
          xAxis: {
            type: 'category',
            // 坐标轴线
            axisLine: {
              lineStyle: {
                color: '#959595'
              }
            },
            // 刻度
            axisTick: {
              show: false
            },
            axisLabel: {
              interval: 0
            }
          },
          yAxis: {
            show: false
          },
          // Declare several bar series, each will be mapped
          // to a column of dataset.source by default.
          // 设置grid滚动
          dataZoom: {
            type: 'slider',
            show: true, //flase直接隐藏图形
            zoomLock: true,
            xAxisIndex: 0,
            height: 10,
            left: 35, //滚动条靠左侧的百分比
            right: 35,
            bottom: 10,
            start: 0,//滚动条的起始位置
            // end: (100 - Math.floor(3 / 6 * 100)), //滚动条的截止位置（按比例分割你的柱状图x轴长度
            end: total <= 2 ? 100 : 100/total,
            // end: 20,
            backgroundColor: '#ddd',
            fillerColor: '#fff',
            textStyle: {
              color: 'rgba(255, 255, 255, 0)'
            },
            showDataShadow: false,//是否显示数据阴影 默认auto  
            showDetail: false,//即拖拽时候是否显示详细数值信息 默认true  
            handleIcon: 'M-292,322.2c-3.2,0-6.4-0.6-9.3-1.9c-2.9-1.2-5.4-2.9-7.6-5.1s-3.9-4.8-5.1-7.6c-1.3-3-1.9-6.1-1.9-9.3c0-3.2,0.6-6.4,1.9-9.3c1.2-2.9,2.9-5.4,5.1-7.6s4.8-3.9,7.6-5.1c3-1.3,6.1-1.9,9.3-1.9c3.2,0,6.4,0.6,9.3,1.9c2.9,1.2,5.4,2.9,7.6,5.1s3.9,4.8,5.1,7.6c1.3,3,1.9,6.1,1.9,9.3c0,3.2-0.6,6.4-1.9,9.3c-1.2,2.9-2.9,5.4-5.1,7.6s-4.8,3.9-7.6,5.1C-285.6,321.5-288.8,322.2-292,322.2z',  
            filterMode: 'filter'
          }
        }
        // 使用刚指定的配置项和数据显示图表。
        myChart.setOption(option)
      },
      // 查询公司设备数量接口
      searchSpace: async function () {
        let vm = this
        let data ={
          area_name: vm.keywords
        }
        // console.log('keyword', vm.keywords)

        let res = await mapApi.searchSpace(data)
        if(res.meta.code === 200) {
          vm.currentMapList = res.data
          vm.currentTableFirstLabel = '公司'
          vm.addInfoPoint()
        } else {
          showToast(res.meta.message)
        }
      },
      // 地图初始化
      mapInit() {
        // 百度地图API功能
        // console.log(this.currentLevelMap);
        // 根据级别和中心点绘制地（默认获取国内，1）
        this.drawMap(this.currentId)
      },
      // 根据级别和中心点绘制地图
      drawMap(id) {
        // 根据级别和位置,设置当前地图列表
        let mapLevel = this.currentLevelMap
        // 获取相对应地区、空间的设备数量
        this.getSpaceDeviceCount(id, mapLevel)

        switch (mapLevel) {
          case 'country':
            this.currentTableFirstLabel = '省'
            break;

          case 'province':
            this.currentTableFirstLabel = '市'
            break;

          case 'city':
            this.currentTableFirstLabel = '区'
            break;

          case 'area':
            this.currentTableFirstLabel = '公司'
            break;
        
          default:
            break;
        }
      },
      // 获取地区、空间的设备数量
      getSpaceDeviceCount: async function (id, area_level) {
        let vm = this
        let data = {
          id: id,
          area_level: area_level
        }

        let res = await mapApi.getSpaceDeviceCount(data)
        if (res.meta.code === 200) {
          vm.currentMapList = res.data
          // 循环添加信息点
          vm.addInfoPoint(vm.currentMapList)
          // 获取公司的设备列表
          if(area_level == 'area') {
            vm.$store.state.spaceID = [res.data[0].id]
            // console.log('refs', vm.$refs)
            if (vm.$refs.singleTable) { vm.$refs.singleTable.setCurrentRow(res.data[0]) }
          }
      // console.log('list', vm.currentMapList)
        } else {
          showToast(res.meta.message)
        }
      },
      // 添加信息点
      addInfoPoint() {
        let vm = this
        // 创建Map实例
        let map = new BMap.Map("allmap");
        // 初始化地图,设置中心点坐标和地图级别(默认中心点为广东)
        let centerPoint = [...vm.defaultLocation];
        map.centerAndZoom(new BMap.Point(centerPoint[0],centerPoint[1]), 7);

        //开启鼠标滚轮缩放
        map.enableScrollWheelZoom(true);
        // 循环添加信息点
        // console.log('vm.currentMapList', vm.currentMapList)
        vm.currentMapList.forEach(function (item, index ) {
          // console.log('item', item)
          let point = new BMap.Point(item.longitude, item.latitude);
          // 设置新icon
          let myIcon = new BMap.Icon('../../static/images/site_icon.png', new BMap.Size(24,24));
          let marker = new BMap.Marker(point, {icon: myIcon});  // 创建标注
          map.addOverlay(marker);              // 将标注添加到地图中
          let size = item.area_level === 'province' ? 5 :
                    item.area_level === 'city' ? 11 :
                    item.area_level === 'area' ? 11 : 14
                    // console.log('size', size)
          map.centerAndZoom(point, size);
          
          let windowUrl = vm.commonUrl + item['area_level'] + '/' + item['id'];
          let labelText = '<a class="go" href="'+ windowUrl + '"><p class="infoW-name">' + item['area_name'] + '</p><p class="infoW-total">' + item['total'] + '个</p></a>';
          let label = new BMap.Label(labelText, {offset: new BMap.Size(12, -83)});
          label.setStyle({
            textAlign: 'center',
            border: 'none',
            fontSize : '18px',
            lineHeight : '1',
            borderRadius: '5px',
            fontFamily:"微软雅黑"
          });
	        marker.setLabel(label);
          // let opts = {
          //   width : 100,     // 信息窗口宽度
          //   height: 100,     // 信息窗口高度
          // };

          // let windowText = item['area_name'] + ':' + item['total'] + '个';

          // // 信息窗口内容
          // let windowUrl = vm.commonUrl + item['area_level'] + '/' + item['id'];
          // let default_windowInfo = `<div class="infoWindow" style="font-size:14px;line-height:20px;">
          //   <p class="encoding" style="margin-top:10px;margin-bottom:40px;font-weight: bold;">${windowText}</p>
          //   <a class="go" href=${windowUrl} style="display:block;width:100%;background-color:#409EFF;color:#fff;text-align:center;border-radius:5px;line-height:25px;margin:5px 0;">
          //     前往查看
          //   </a>
          // </div>`;
          // // 公司信息窗口内容
          // let company_windowInfo = `<div class="infoWindow" style="font-size:14px;line-height:20px;">
          //   <p class="encoding" style="margin-top:10px;margin-bottom:40px;font-weight: bold;">${windowText}</p>
          // </div>`;

          // let windowInfo = item['area_level'] === 'space_one' ? company_windowInfo : default_windowInfo
          // let infoWindow = new BMap.InfoWindow(windowInfo, opts);  // 创建信息窗口对象 
          // marker.addEventListener('mouseover', ()=> {
          //   map.openInfoWindow(infoWindow,point); //开启信息窗口
          // });

        })
      },
      //返回上一级
      back(){
        this.$router.go(-1);
      },
      // 点击地址导航栏获取新的列表
      getNewMapList: function (row) {
        // console.log('row', row)
        if (row.area_level === 'space_one' && this.currentLevelMap == 'area') {
          this.$store.state.spaceID = [row.id]
          return
        }
        // 路由跳转
        let windowUrl = this.commonUrl + row.area_level + '/' + row.id;
        window.location.href= windowUrl;
      },
    },
    watch: {
      // 监听当前显示地区，控制地图显示
      'currentLevelMap': function (newVal, oldVal) {
        // console.log('newVal', newVal)
        // console.log('oldVal', oldVal)
        if (oldVal == 'area') {
          this.analyze()
        }
        if (newVal == 'area') {
          // $store.state.spaceID
          // console.log('currentMapList', this.currentMapList)
        }
      },
      // 监听id的变化，获取新的设备列表
      '$route.params.id': function (newVal) {
        // console.log('newVal::::', newVal, this.$route.params.mapLevel)
        if (newVal) {
          this.currentLevelMap = this.$route.params.mapLevel
          this.drawMap(newVal)
        } else {
          this.currentLevelMap = 'country'
          this.drawMap('1')
        }
      },
      // 监听搜索字段的变化，清空显示默认设备信息
      'keywords': function (newVal) {
        if (newVal === '') {
          this.mapInit()
        }
      }
    },
    computed: {
    }
  }
</script>

<style lang="scss">
$bgColor: rgba(255, 255, 255, 0.8);
.CMap {
  // 导航
  .MapNavBar {
    flex-shrink: 0;
    width: 450px;
    background-color: #121920;
    overflow: hidden;
    position: relative;
    .return {
      margin: 7.5px 0;
      font-size: 30px;
      font-weight: bold;
      color: #555555;
      position: absolute;
      left: 15px;
      top: 40px;
      z-index: 2;
    }
    // 搜索框
    .search {
      width: 100%;
      padding: 22px 29px 20px 28px;
      position: relative;
      .input {
        input {
          background-color: #121920;
          border-color: #535353;
        }
        .el-input__suffix {
          margin-right: 40px;
        }
      }
      .icon {
        color: #999999;
        position: absolute;
        right: 46px;
        top: 35px;
      }
    }
    // 表格列表
    .deviceList::after {
      content: '';
      width: 32px;
      height: 40px;
      background-color: #00111f;
      position: absolute;
      right: 0;
      top: 0;
    }
    .deviceList {
      width: 450px;
      height: calc(100vh - 118px - 92px - 83px);
      padding-right: 32px;
      position: relative;
      .table::before {
        height: 0;
      }
      .table {
        width: 418px;
        height: 100%;
        background-color: #121920;
        .cell {
          text-align: left;
          padding-left: 30px;
          color: #ffffff;
          font-size: 18px;
        }
        th,td {
          border-bottom: none;
          padding: 0;
        }
        th {
          background-color: #00111f;
        }
        // 滚动区域
        .el-table__body-wrapper {
          width: 438px;
          background-color: #121920;
        }
        // 表头
        .list-title {
          height: 40px;
          line-height: 40px;
        }
        // 表行
        .list-row td {
          height: 68px;
          line-height: 68px;
          background-color: #121920;
          position: relative;
        }
        .list-row td::after {
          content: '';
          width: 100%;
          border-top: 1px solid #535353;
          position: absolute;
          bottom: 1px;
          left: 0;
          z-index: 5;
        }
        .list-row:hover>td {
          background-color: #121920;
        }
        .list-row.current-row{
          .cell {
            color: #0081eb;
          }
        }
      }
      .deviceMapInfo {
        padding: 3px;
        margin: -3px;
      }
    }
    // 控制台
    .moreLink {
      width: 390px;
      line-height: 50px;
      font-size: 24px;
      color: #ffffff;
      background-color: #0081eb;
      border-radius: 10px;
      text-align: center;
      position: absolute;
      bottom: 33px;
      right: 0;
      left: 0;
      margin: 0 auto;
    }
  }
  .rightArea {
    overflow-y: hidden !important;
    position: relative;
    // 主地图
    #allmap{
      width: 100%;
      height: 100%;
      overflow: hidden;
      // 地图信息窗口
      .BMapLabel {
        transform: translateX(-50%);
        box-shadow: 10px 10px 10px #b1afb0;
        .go {
          display: block;
          padding: 10px 24px 12px;
          color: #999999;
          .infoW-total {
            margin-top: 8px;
            color: #096cf1;
          }
        }
      }
      .BMapLabel::after {
        content: '';
        display:block;
        width: 0;
        height: 0;
        border-width: 13px 6.5px 0;
        border-style: solid;
        border-color: #ffffff transparent transparent;/*透明 透明  黄*/
        transform: translateX(-50%);
        position: absolute;
        left: 50%;
        bottom: -13px;
      }
    }
    // 设备中心
    .deviceCenter {
      // height: 100%;
      height: calc(100vh - 164px);
      overflow: auto;
      margin-top: 74px;
      box-sizing: border-box;
      padding: 0px 74px 50px;
      .CDeviceComponent {
        min-height: 800px;
        background-color: #f0f3f8;
        border-radius: 10px;
        .tit {
          border-top-left-radius: 10px;
          border-top-right-radius: 10px;
          &.bgd2{
            border-radius: 0;
          }
        }
      }
    }
    // 按钮区域
    .btnArea {
      display: flex;
      position: absolute;
      left: 12px;
      top: 17px;
      z-index: 10;
      .btn {
        width: 118px;
        height: 40px;
        line-height: 40px;
        font-size: 16px;
        color: #ffffff;
        border-radius: 5px;
        background-color: rgba(0, 0, 0, 0.5);
        i{
          margin-left: 13px;
          font-size: 20px;
        }
      }
      .btn+.btn{
        margin-left: 10px;
      }
    }
    // 悬浮信息
    .suspendInfoScrollWrapper {
      width: 350px;
      height: 100%;
      overflow: hidden;
      position: absolute;
      right: 24px;
      top: 0;
      .suspendInfoScrollBox {
        width: 370px;
        height: 100%;
        overflow-y: scroll;
      }
    }
    .infoSuspendWrapper {
      width: 350px;
      border: none;
      padding-top: 15px;
      .box{
        width: 350px;
        margin-bottom: 10px;
        border-radius: 8px;
      }
      .box.is-active{
        height: auto;
        .el-collapse-item__header {
          border-bottom-left-radius: 0;
          border-bottom-right-radius: 0;  
        }
      }
      // title
      .el-collapse-item__header {
        height: 40px;
        line-height: 40px;
        padding-left: 22px;
        border-bottom: none;
        border-radius: 8px;
        background-color: $bgColor;
      }
      .el-collapse-item__arrow {
        font-size: 30px;
      }
      .el-collapse-item__wrap {
        background-color: $bgColor;
        border-bottom: none;
        border-bottom-left-radius: 8px;
        border-bottom-right-radius: 8px;   
      }
      .el-collapse-item__content {
        padding-bottom: 0;    
      }

      // 设备状态
      .content {
        height: 230px;
        display: flex;
        align-items: center;
          .swiper-container {
            margin: 0;
            // padding: 20px 0;
            padding-top: 20px;
            padding-bottom: 20px;
            width: 174px;
            height: 180px;
            text-align: center;
            .swiper-slide {
              height: 28px;
              line-height: 28px;
              opacity: 1;
            }
            .swiper-slide.activeDevice {
              color: #0081eb;
              font-weight: bold;
            }
            .swiper-slide.opacity {
              opacity: 0;
            }
            .el-icon-caret-bottom,
            .el-icon-caret-top{
              width: 100%;
              height: 28px;
              background: none;
              background-color: transparent;
              font-size: 18px;
              color: #959595;
              left: 0;
              right: 0;
              margin: auto;
              z-index: 999;
            }
            .el-icon-caret-top {
              top: 0;
            }
            .el-icon-caret-bottom {
              top: 160px;
              // z-index: 9999;
            }
            .swiper-button-prev.swiper-button-disabled, .swiper-button-next.swiper-button-disabled {
              opacity: 1;
              color: #ffffff;
            }
            
          }
          .circle {
            width: 120px;
            height: 120px;
            padding-top: 27px;
            border-radius: 50%;
            background-color: #13b5b1;
            text-align: center;
            color: #ffffff;
            .text {
              font-size: 18px;
              line-height: 1;
            }
            .rate {
              font-size: 20px;
              margin: 11px 0 15px;
            }
            .total {
              font-size: 12px;
            }
          }
      }
      // 空间分布
      #spaceDis {
        width: 100%;
        height: 230px;
      }
      // 预警中心
      .errorCenter{
        padding: 10px 0 10px 18px;
        .el-table{
            background-color: transparent;
            opacity: 0.8;
          tr {
            background-color: transparent;
          }
        }
        .el-table::before{
          width: 20px;
          height: 100%;
          background-color: transparent;
          left: auto;
          right: 0;
          top: 0;
        }
        .cellStyle {
          background-color: transparent;
          padding: 8px 0;
          border-bottom: none;
          font-size: 12px;
          .cell {
            line-height: 16px;
          }
        }
        .headerStyle {
          background-color: transparent;
          padding: 0;
          font-size: 12px;
          line-height: 21px;
          color: #999999;
        }
      }
    }
  }
}
  
</style>




// WEBPACK FOOTER //
// src/components/CMap.vue